import React from 'react';

const Footer = () => {
    return (
        <footer className='footer'>
            <p>&copy; Jessica Sandler 2022</p>
        </footer>
    );
};

export default Footer;